<template>
  <span class="d-in-block" :style="{width: width, height: height}">
    
    <component
      :is="tootipCmpt"
      :content="$t('pc_biz_lbl_joinlib'/** 加入知识库 */)"
      placement="top"
      :disabled="disabled || noTooltip"
    >
      <slot v-if="$slots.default"></slot>
      <yxtf-svg
        v-else
        width="100%"
        height="100%"
        :remote-url="svgUrl"
        icon-class="folder-icon"
        :class="[disabled ? 'yxtbiz-joinlib_notallowed' : 'hand']"
        @click.native.stop="showDialog"
      />
    </component>
    <!-- dialog -->
    <MainDialog
      v-if="show"
      ref="dialog"
      :scene="scene"
      :file-id="fileId"
      :file-name="fileName"
      :file-size="fileSize"
      :file-size-type="fileSizeType"
      :file-ext="fileExt"
      :storage-type="storageType"
      :link="link"
      :linkName="linkName"
      :intraLink="intraLink"
    />
  </span>
</template>

<script>
import { Tooltip, FrontTooltip } from 'yxt-pc';
import MainDialog from './components/dialog.vue';
export default {
  name: 'YxtbizFileJoinKnglib',
  name_zh: '加入知识库',
  provide() {
    return {
      svgUrl: this.svgUrl,
      submitSensors: this.submitSensors,
      isBack: this.isBack
    };
  },
  components: { MainDialog },
  props: {
    disabled: {
      type: Boolean,
      default: false,
      desc: '是否禁用',
      setter: 'BooleanSetter'
    },
    width: {
      type: String,
      default: '20px',
      desc: '图标宽度',
      setter: 'StringSetter'
    },
    height: {
      type: String,
      default: '20px',
      desc: '图标高度',
      setter: 'StringSetter'
    },
    fileId: {
      type: String,
      required: true,
      desc: '文件 id',
      setter: 'StringSetter'
    },
    fileName: {
      type: String,
      default: '',
      desc: '文件名称',
      setter: 'StringSetter'
    },
    fileSize: {
      type: Number,
      required: true,
      desc: '文件大小',
      setter: 'NumberSetter'
    },
    fileSizeType: {
      type: String,
      default: 'BYTE',
      desc: '文件大小单位，可选值："BYTE"-组件内将fileSize转换为KB；"KB"-组件内不转换',
      setter: 'TabSetter',
      enums: [{
        label: 'BYTE',
        value: 'BYTE'
      }, {
        label: 'KB',
        value: 'KB'
      }]
    },
    fileExt: {
      type: String,
      required: true,
      desc: '必传，文件扩展名，比如 .jpg、jpg、.mp4、mp4',
      setter: 'StringSetter'
    },
    storageType: {
      type: [String, Number],
      default: 1,
      desc: '文件的存储方式：1-公有云存储，2-私有云存储',
      setter: 'TabSetter',
      enums: [{
        label: '公有云存储',
        value: '1'
      }, {
        label: '私有云存储',
        value: '2'
      }]
    },
    scene: {
      type: [String, Number],
      default: 1,
      desc: '组件使用场景，可选值：1.培训作业-学员端 2.培训作业-管理端 3.面授 4.下载中心',
      setter: 'StringSetter'
    },
    sensors: {
      type: Object,
      default() { return {}; },
      desc: '神策,废弃',
      setter: 'JsonSetter'
    },
    isBack: {
      type: Boolean,
      desc: 'false-学员端 true-管理端',
      setter: 'BooleanSetter'
    },
    link: {
      type: String,
      desc: '外链',
      setter: 'StringSetter'
    },
    linkName: {
      type: String,
      desc: '外链名称',
      setter: 'StringSetter'
    },
    intraLink: {
      type: Boolean,
      default: false,
      desc: '是否是内部链接',
      setter: 'BooleanSetter'
    },
    noTooltip: {
      type: Boolean,
      default: false,
      desc: '不展示文字提示',
      setter: 'BooleanSetter'
    }
  },
  data() {
    return {
      show: false,
      svgUrl: `${this.$staticBaseUrl}ufd/407a24/knglib/pc/svg/`
    };
  },
  computed: {
    tootipCmpt() {
      return this.isBack ? Tooltip : FrontTooltip;
    }
  },
  methods: {
    showDialog() {
      if (this.disabled) return;
      this.show = true;
      this.$nextTick(() => {
        this.$refs.dialog.init(true).then(() => {
          this.show = false;
        });
      });
      // 上报神策日志：加入知识库按钮点击量统计
      this.submitSensors('kng_add_click', {
        scene: this.scene
      });
    },
    /**
     * 提交神策日志
     * @param {string} eventName 神策事件名
     * @param {object} params 提交内容属性
     */
    submitSensors(eventName, params) {
      if (!this.sensors || !this.sensors.track || typeof this.sensors.track !== 'function') {
        return console.log('Current page no sensors');
      }
      this.sensors.track(eventName, params || {});
    }
  }
};
</script>
